import React, { lazy, Suspense, useMemo } from 'react';
import { DWTModuleLoading } from './dwt-loading';

export type ComponentLoadFunction<P> = () => Promise<React.ComponentType<P>>;

export const wrapAsDefault = <Component extends unknown>(x: Component) => ({ default: x } as const);

export const DWTLoadable = (component: ComponentLoadFunction<any>) => (props: any) => {
  const LazyComponent = useMemo(() => lazy(() => component().then((c) => ({ default: c }))), [component]);
  return (
    <Suspense fallback={<DWTModuleLoading />}>
      <LazyComponent {...(props as any)} />
    </Suspense>
  );
};

export const DWTLoadableComponentPart = (component: ComponentLoadFunction<any>) => (props: any) => {
  const LazyComponent = lazy(() =>
    component().then((c) => {
      return { default: c };
    })
  );
  return (
    <Suspense fallback={null}>
      <LazyComponent {...(props as any)} />
    </Suspense>
  );
};
